export function getHasGretaAIChatProjectHiddenChats({ chats, visibleChats }) {
  return visibleChats.length < chats.length
}
